<template>
  <ab-flow-base-cmp :movable="true" :block="block" class="fake-logic-editor-cmp">

    <ab-flow-link-connector :block="block" type="input" class="ev-run" event="run"/>

    <q-card class="bg-yellow-1">
      <q-card-section class="bg-yellow-8">{{title}}</q-card-section>
      <q-card-section class="desc ellipsis">
        {{description}}
      </q-card-section>
    </q-card>

    <div class="results">
      <ab-flow-link-connector v-for="(e, k) of outEvents" class="q-mt-sm" :block="block" type="output" :event="e.name" :key="k"/>
    </div>

  </ab-flow-base-cmp>
</template>

<script>

import AbFlowBaseCmp from "ab-flow-designer/src/components/Designer/AbFlowBaseCmp";
import AbFlowLinkConnector from "ab-flow-designer/src/components/Designer/AbFlowLinkConnector";

export default {
  components: { AbFlowBaseCmp, AbFlowLinkConnector},
  inject: ['canvas'],
  props: ['block'],
  name: "FakeLogicEditorCmp",
  computed: {

    /* Events list
        * @return {*|*[]}
  */
    outEvents() {
      return this.block.properties && this.block.properties.events ? this.block.properties.events : []
    },


    /**
     * Return desc
     * @return {{}}
     */
    description() {
      return this.block.properties ? this.block.properties.description : "No description"
    },
    /**
     * Return title
     * @return {{}}
     */
    title() {
      return this.block.properties ? this.block.properties.title : "No title"
    },
  }
}

</script>

<style lang="scss">

.fake-logic-editor-cmp {

  max-width: 300px;

  .ev-run {
    left:-12px;
    position: absolute;
    top:calc(50% - 5px);
  }

  .desc {
    max-width: 250px;
  }

  .results {
    position: absolute;
    right: -12px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}

</style>
